import { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Header,
  HeaderProps,
  HeaderTitle,
} from '@rossum/components/header/Header';
import { Button, Chip, Dialog, Stack } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import { CreateLabelDialog } from './LabelDialogs';

type LabelsHeaderProps = { labelsCount: number } & Pick<
  HeaderProps,
  'scrollableDivRef'
>;

export const LabelsHeader = ({ labelsCount, ...rest }: LabelsHeaderProps) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const intl = useIntl();

  return (
    <>
      <Header
        {...rest}
        breadcrumbs={
          <SettingsBreadcrumbs
            breadcrumbs={[
              {
                label: intl.formatMessage({
                  id: 'components.appBar.menu.settings.labels',
                }),
              },
            ]}
          />
        }
        title={hasScrolled => (
          <Stack direction="row" alignItems="center" gap={1}>
            <HeaderTitle
              hasScrolled={hasScrolled}
              title={intl.formatMessage({
                id: 'containers.settings.labels.header.title',
              })}
            />
            <Chip label={labelsCount} />
          </Stack>
        )}
        description={intl.formatMessage({
          id: 'containers.settings.labels.description',
        })}
        buttons={[
          <Button
            key="add"
            variant="contained"
            color="primary"
            sx={{ ml: 'auto' }}
            onClick={() => setShowDialog(true)}
          >
            {intl.formatMessage({
              id: 'containers.settings.labels.actions.createNew',
            })}
          </Button>,
        ]}
      />
      <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
        <CreateLabelDialog onClose={() => setShowDialog(false)} />
      </Dialog>
    </>
  );
};
